import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "918900964069"; // country + number (no +)

export const api = axios.create({ baseURL: API });

export const setAdminToken = (token) => {
  if (token) {
    localStorage.setItem("admin_token", token);
  } else {
    localStorage.removeItem("admin_token");
  }
};

export const getAdminToken = () => localStorage.getItem("admin_token");

api.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers["x-admin-token"] = token;
  }
  return config;
});

export const adminHeaders = () => ({
  headers: { "x-admin-token": getAdminToken() || "" },
});

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Hi Journey To Andaman! I'd like to know more about your Andaman packages.",
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n || 0);
